/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ failed: NonNullable<unknown>, total: NonNullable<unknown>, orderNumber: NonNullable<unknown> }} Orders_Docs_Generated_FailureInputs */

const en_orders_docs_generated_failure = /** @type {(inputs: Orders_Docs_Generated_FailureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.failed} of ${i?.total} documents failed for ${i?.orderNumber}`)
};

const es_orders_docs_generated_failure = /** @type {(inputs: Orders_Docs_Generated_FailureInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fallaron ${i?.failed} de ${i?.total} documentos para ${i?.orderNumber}`)
};

/**
* | output |
* | --- |
* | "{failed} of {total} documents failed for {orderNumber}" |
*
* @param {Orders_Docs_Generated_FailureInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_docs_generated_failure = /** @type {((inputs: Orders_Docs_Generated_FailureInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Docs_Generated_FailureInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_docs_generated_failure(inputs)
	return es_orders_docs_generated_failure(inputs)
});